import { useRoute } from 'vue-router'
export default {
    name: 'Paid',

    components: {

    },

    data() {
        return {
            loading: false,
            success: false,
            seconds: 5,
            timer: null
        }
    },

    methods: {
        async populateData() {
            this.loading = true;
            try {
                const result = await this.ApiRequest.requestAsync(
                    `stripe/subscribe/paid/${useRoute().params.token}`,
                    this.ApiRequest.REQUEST_GET,
                    [],
                    'get-paid',
                    true
                );
                const data = result.data;
                if (!data) {
                    return;
                }

                this.success = data.success;
                this.timer = setInterval(() => {
                    this.seconds--;
                    if (this.seconds <= 0) {
                        clearInterval(this.timer);
                        this.$router.push('/billing/subscribe');
                    }
                }, 1000);

            } finally {
                this.loading = false;
            }
        }
    },

    beforeUnmount() {
        clearInterval(this.timer)
    },

    beforeMount() {
        this.populateData();
    },
}
